import React, { Component } from 'react'
import { GradePickerComponent } from '../../gradePicker';
import { MuiGrid, MuiTextField, MuiIconButton, MuiClear, MuiEdit, MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import AutoCompleteComponent from './AutoCompleteComponent';
import lodashUtil from 'lodash';
import { gradePickerUtil } from '../../gradePicker';
import spinner from "../../../ui/icons/spinner.gif"
import { toast } from 'react-toastify';
import AlertDialogComponent from '../teacher/AlertDialogComponent';
import { rulesUtil } from '../rules/dialog'

export class AddSubjectsComponent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			open: false,
			code: undefined,
			toggleChange: false,
			gradeLevelsToBeRendered: [],
			gradeString: "All Grades",
			showDeleteConfirmDialog: false,
			showGradeDetailChangeConfirmDialog: false,
			gradeDetails: undefined,
			constraintsArray: [
				"fixedTeachersAndTAsForElectives",
				"numberOfTeachersAndTAsForSubjects",
				"fixedTeachersAndTAsForSubjects",
				"multiPeriods",
				"preferredPeriods",
				"sharedRoomsForSubjects",
				"totalPeriods",
				"jointClasses",
				"numberOfTeachersAndTAsForElectives",
				"sharedRoomsForElectives"
			],
			confimationDialogSubjects: false

		}
	}

	handleOpen = () => {
		if (this.props.subject.gradeDetails !== undefined && !lodashUtil.isEmpty(this.props.subject.gradeDetails)) {
			let gradeLevels = gradePickerUtil.constructGradeLevelJSON(this.props.gradeLevelsToBeRendered, this.props.subject.gradeDetails)
			this.setState({
				gradeLevelsToBeRendered: gradeLevels
			})
		} else {
			let gradeLevels = gradePickerUtil.constructGradeLevelJSONToBeRendered(this.props.gradeLevelsToBeRendered)
			this.setState({
				gradeLevelsToBeRendered: gradeLevels
			})
		}

		this.setState({ open: true, toggleChange: !this.state.toggleChange })

	};

	handleClose = () => {

		this.setState({ open: false })
	};

	compareGradeDetails = (oldGD, newGD) => {
		//check if ALL GRADES is TRUE
		if (oldGD.allGrades !== newGD.allGrades) {
			return true;
		}
		// ALL GRADES is FALSE
		else {
			if (oldGD.gradeLevels.length !== newGD.gradeLevels.length) {
				return true;
			}
			// if GRADELEVEL length is same then check the data within it.
			else {
				for (let i = 0; i < oldGD.gradeLevels.length; i++) {
					if (oldGD.gradeLevels[i].level !== newGD.gradeLevels[i].level) {
						return true;
					}
				}
			}
			if (oldGD.grades.length !== newGD.grades.length) {
				return true;
			}
			// if GRADES length is not same check for the data
			else {
				for (let i = 0; i < oldGD.grades.length; i++) {
					if (oldGD.grades[i].level !== newGD.grades[i].level) {
						return true;
					}
				}
			}
		}
		return false;
	}



	onClickOfSaveInGradePicker = (gradeDetails) => {
		let teachers = this.props.activeSchool.school_master.teachers;
		let electiveList = this.props.activeSchool.school_master.electives
		let subject = this.props.subject;
		let subjectToBeSaved = true;
		let findSubjectInTeacher = false;
		if (subject._id != undefined) {
			let oldGradeDetail = gradePickerUtil.convertingGradeDetailsToLowestFormat(subject.gradeDetails, this.props);
			let newGradeDetail = gradePickerUtil.convertingGradeDetailsToLowestFormat(gradeDetails, this.props);
			if (oldGradeDetail.length === newGradeDetail.length) {
				let checkIfGradeDetailIsChanged = lodashUtil.difference(oldGradeDetail, newGradeDetail);
				if (checkIfGradeDetailIsChanged.length !== 0) {
					this.props.updateData()
					findSubjectInTeacher = true
				}
			} else {
				findSubjectInTeacher = true
				this.props.updateData()
			}
		}

		if (findSubjectInTeacher === true) {
			if (teachers.length > 0) {
				for (let i = 0; i < teachers.length; i++) {
					let assignedSubjects = teachers[i].assignedSubjects;
					let subObjIndex = lodashUtil.find(assignedSubjects, ["subjectName", subject.name]);
					if (subObjIndex != undefined) {
						subjectToBeSaved = false
						this.setState({
							showGradeDetailChangeConfirmDialog: true
						})
						break;
					}
				}
			}
			if (electiveList.length > 0) {
				for (let j = 0; j < electiveList.length; j++) {
					let subjects = electiveList[j].subjects
					let subObj = lodashUtil.find(subjects, ["name", subject.name]);

					if (subObj != undefined) {

						subjectToBeSaved = false
						this.setState({
							showGradeDetailChangeConfirmDialog: true
						})
						break;
					}
				}
			}
			let scheduleConstraints = this.props.activeSchool.schedule_constraints
			if (rulesUtil.checkIfGradeDetailsAreChanged(this.state.constraintsArray, gradeDetails, "showGradeDetailChangeConfirmDialog", this.props.subject, scheduleConstraints, this.props)) {
				subjectToBeSaved = false
				this.setState({
					showGradeDetailChangeConfirmDialog: true
				})
			}
		}

		if (subjectToBeSaved === true) {
			let gradeString = gradePickerUtil.getGradesString(gradeDetails);
			subject.gradeDetails = gradeDetails;
			this.props.updateData()
			this.setState({
				gradeString: gradeString
			})
		}

		this.setState({
			gradeDetails: gradeDetails,
			open: false,
		})
	}

	onChange = (name, event, index) => {
		this.props.subject[name] = event.target.value
		this.setState({
			toggleChange: !this.state.toggleChange,
		})
	}

	handeleDeleteSubject = async () => {
		let key = this.props.index
		await this.props.removeSubjectFromSubjectList(key)
		this.props.updateData()
		if (!this.props.confimationDialogSubjects.isChanged) {
			this.props.confimationDialogSubjects.isChanged = true
		}
		this.setState({
			showDeleteConfirmDialog: false,
		})
	}


	handleChangeForSubjectCode = (subjectName) => {
		if (subjectName != null) {
			this.props.subjectMasterData.subjects.map((subjectObj) => {
				if (subjectObj.subjectName.toLowerCase() === subjectName.toLowerCase()) {
					this.props.subject.code = subjectObj.subjectId
					this.setState({
						code: this.props.subject.code,
					})
				}
			})
		}
		else {
			this.setState({
				code: ''
			})
		}
		this.props.updateData()

	}
	componentWillMount() {
		let gradeDetails = this.props.subject.gradeDetails
		let gradeString = gradePickerUtil.getGradesString(gradeDetails);
		this.setState({ toggleChange: !this.state.toggleChange, open: false, gradeString: gradeString })
	}
	//Generating subject code 
	generatingSubjectCode = (subjectName) => {
		let subjectCode;
		if (subjectName !== null) {
			subjectCode = this.checkingSubjectCodeExists(subjectName);
		}
		if (subjectCode !== undefined) {
			this.props.subject.code = subjectCode.trim()
			this.setState({
				code: this.props.subject.code
			})
		}
		this.props.updateData()
	}

	// check if the subject code is already assigned to a particular subject
	checkingSubjectCodeExists = (name) => {
		let isIdTaken = undefined;
		let isSubjectCodeTaken = undefined
		let count = 0;
		let subjectCode;
		let first3LettersOfName;
		if (name !== "") {
			let isSubjectPresent = this.props.subjectMasterData.subjects.some(subjects => subjects.subjectName.toLowerCase() === this.props.subject.name.toLowerCase())
			if (isSubjectPresent === false) {
				let subjectArray = this.props.subjectMasterData.subjects
				first3LettersOfName = name.substring(0, 3).toUpperCase();
				subjectCode = first3LettersOfName;
				while (isIdTaken === undefined && isSubjectCodeTaken === undefined) {
					if (subjectArray.length === 0) {
					} else {
						if (count != 0) {
							subjectCode = (first3LettersOfName + count);
						}
						isIdTaken = lodashUtil.find(subjectArray, ['subjectId', subjectCode]);
						isSubjectCodeTaken = lodashUtil.find(this.props.subjectList, ['code', subjectCode])
						if (isIdTaken === undefined && isSubjectCodeTaken === undefined) {
							return subjectCode;
						} else {
							count++;
							isIdTaken = undefined;
							isSubjectCodeTaken = undefined
						}
					}
				}
			} else {
				if (this.props.subject.code === undefined) {
					this.handleChangeForSubjectCode(name)
				}
			}
			if (!this.props.confimationDialogSubjects.isChanged) {
				this.props.confimationDialogSubjects.isChanged = true
			}
		}
	}

	onChangeSubjectCode = (code, event) => {
		const i18n = this.props.i18n
		let subject = this.props.subject
		if (this.props.subject.name !== undefined && this.props.subject.name !== "") {
			let isSubjectPresent = this.props.subjectMasterData.subjects.some(subjects => subjects.subjectName === this.props.subject.name)
			if (isSubjectPresent === false) {
				subject[code] = event.target.value.toUpperCase()
				this.setState({
					code: event.target.value,
				})

			}
		}
		else {
			toast(i18n.subjects.subjectNameIsEmpty)
			this.props.subject.code = ""
			this.setState({
				code: this.props.subject.code
			})
		}
		this.setState({
			toggleChange: !this.state.toggleChange,
		})
		this.props.updateData()
	}

	onClickOfDeleteSubject = (subject) => {
		const i18n = this.props.i18n
		let isSubjectPresent = false;
		let electiveList = this.props.activeSchool.school_master.electives;
		let teacherList = this.props.activeSchool.school_master.teachers;
		for (let x = 0; x < electiveList.length; x++) {
			let electiveSubjects = electiveList[x].subjects;
			let subjectObj = lodashUtil.find(electiveSubjects, ["name", subject.name]);
			if (subjectObj !== undefined) {
				isSubjectPresent = true
				this.setState({
					showDeleteConfirmDialog: true,
					errorMessage: i18n.subjects.deletingSubject
				})
				break;
			}
		}
		if (isSubjectPresent === false) {
			for (let y = 0; y < teacherList.length; y++) {
				let assignedSubjects = teacherList[y].assignedSubjects
				let subjectObj = lodashUtil.find(assignedSubjects, ["subjectName", subject.name]);
				if (subjectObj != undefined) {
					isSubjectPresent = true
					this.setState({
						showDeleteConfirmDialog: true,
						errorMessage: i18n.subjects.deletingSubject
					})
				}
			}
		}
		if (isSubjectPresent === false) {
			this.handeleDeleteSubject();
		}
	}

	handleCloseDialog = () => {
		this.setState({ showDeleteConfirmDialog: false });
	}

	deletingSubjectInTeachers = () => {
		let gradeDetails = this.state.gradeDetails;
		let gradeString = gradePickerUtil.getGradesString(gradeDetails);
		this.removingOfSubjectInTeachersAndElectives();
		this.props.subject.gradeDetails = gradeDetails;
		this.setState({
			gradeString: gradeString,
			showGradeDetailChangeConfirmDialog: false
		})
	}

	removingOfSubjectInTeachersAndElectives = () => {
		
		let electiveList = this.props.activeSchool.school_master.electives;
		let teachers = this.props.activeSchool.school_master.teachers;
		let subject = this.props.subject;
		for (let i = 0; i < teachers.length; i++) {
			let assignedSubjects = teachers[i].assignedSubjects;
			let subObjIndex = lodashUtil.findIndex(assignedSubjects, ["subjectName", subject.name]);
			if (subObjIndex !== -1) {
				assignedSubjects.splice(subObjIndex, 1);
			}
		}
		if (electiveList.length > 0) {
			for (let j = 0; j < electiveList.length; j++) {
				let subjects = electiveList[j].subjects
				let subObj = lodashUtil.findIndex(subjects, ["name", subject.name]);
				if (subObj !== -1) {
					if (subjects.length <= 2) {
						rulesUtil.deleteRulesIfGradedetailsChanged(this.props.activeSchool.schedule_constraints, this.state.constraintsArray, electiveList[j])
						electiveList.splice(j, 1)
						j -= 1
					} else {
						subjects.splice(subObj, 1)
					}
				}
			}
		}
		let scheduleConstraints = this.props.activeSchool.schedule_constraints
		this.props.subject.isSubject = true
		rulesUtil.deleteRulesIfGradedetailsChanged(scheduleConstraints, this.state.constraintsArray, this.props.subject)
	}

	closeDialogWithoutDeleting = () => {
		this.setState({
			showGradeDetailChangeConfirmDialog: false,
		});
	}

	render() {
		const { i18n } = this.props
		return (<div>
			{this.state.open === true &&
				<GradePickerComponent
					gradeLevels={this.props.gradeLevelsToBeRendered}
					{...this.state}
					{...this.props}
					handleClose={this.handleClose}
					handleOpen={this.handleOpen}
					onClickOfSaveInGradePicker={this.onClickOfSaveInGradePicker}
				/>
			}
			<MuiGrid container xs={12}>
				{this.props.getSubjectsInProgress == true && this.props.getSubjectMasterDataInProgress == true && (
					<img
						src={spinner}
						alt="none"
						style={theme.spinnerImgStyle}
					/>
				)}
				<MuiGrid item xs={4} style={theme.gridTableStyle}>

					{<AutoCompleteComponent {...this.props}   {...this.state}

						value={this.props.subject.name}
						handleChangeForSubjectCode={this.handleChangeForSubjectCode}
						generatingSubjectCode={this.generatingSubjectCode} />}

				</MuiGrid>
				<MuiGrid item xs={2} style={theme.gridTableSelectStyle}>
					<MuiTextField
						id="subject code"
						value={this.props.subject.code}
						onChange={(event) => this.onChangeSubjectCode('code', event)}
						//variant="outlined"
						InputProps={{ native: true, disableUnderline: true }}
						style={{ width: "100%", height: "100%" }}
					/>
				</MuiGrid>
				{/* <MuiGrid item xs={2} style={theme.gridTableSelectStyle}>
					<MuiTextField
						id="description"
						value={this.props.subject.description}
						onChange={(event) => { this.onChange('description', event) }}
						InputProps={{ native: true, disableUnderline: true }}
						style={{ width: "100%", height: "100%" }}
					/>
				</MuiGrid> */}
				<MuiGrid item xs style={theme.gridTableBeforeEditStyle} container alignItems="center" justify="center">
					<MuiTypography>{gradePickerUtil.getGradesString(this.props.subject.gradeDetails)}</MuiTypography>
				</MuiGrid>
				< MuiGrid item style={theme.gridTableEditStyle} justify="center" align="center">
					<MuiIconButton onClick={() => this.handleOpen()} id="editButton" >
						< MuiEdit id="editButton" style={{ color: theme.palette.grey.dark }} />
					</MuiIconButton>
				</MuiGrid>
				< MuiGrid item style={theme.gridTableClearButtonStyle} justify="center " alignContent="center">
					<MuiIconButton onClick={() => this.onClickOfDeleteSubject(this.props.subject)} id="delete">
						<MuiClear style={{ color: theme.palette.grey.dark }} />
					</MuiIconButton>
				</ MuiGrid>

				{this.state.showDeleteConfirmDialog &&
					<AlertDialogComponent
						{...this.props}
						errorMessage={this.state.errorMessage}
						handleCloseDialog={this.handleCloseDialog}
						openDialog={this.state.showDeleteConfirmDialog}
						handleClickOnYes={this.handeleDeleteSubject}
					/>
				}

				{this.state.showGradeDetailChangeConfirmDialog &&
					<AlertDialogComponent
						{...this.props}
						errorMessage={i18n.subjects.relatedInfoDeletingMsg}
						handleCloseDialog={this.closeDialogWithoutDeleting}
						openDialog={this.state.showGradeDetailChangeConfirmDialog}
						handleClickOnYes={this.deletingSubjectInTeachers}
					/>
				}
			</MuiGrid>
		</div>
		)
	}
}

export default AddSubjectsComponent
